<template>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css">
  <div class="d-flex flex-column min-vh-100">
    <NavBar />
    <main class="flex-grow-1">
      <router-view />
    </main>
    <SiteFooter  />
  </div>
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import SiteFooter  from './components/SiteFooter.vue'
</script>